import { getGoToFairePosCTA } from "./shared";
export var UnlinkingPosIA = function UnlinkingPosIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToFairePosCTA;
        return (_getGoToFairePosCTA = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA === void 0 ? void 0 : _getGoToFairePosCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToFairePosCTA2, _getGoToFairePosCTA2$;
        return (_getGoToFairePosCTA2 = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA2 === void 0 ? void 0 : (_getGoToFairePosCTA2$ = _getGoToFairePosCTA2.getLink) === null || _getGoToFairePosCTA2$ === void 0 ? void 0 : _getGoToFairePosCTA2$.call(_getGoToFairePosCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UNLINKING_POS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION(strictLocalize), TO_RECONNECT_A_DIFFERENT_ACCOUNT(strictLocalize)];
    }
  };
};
var UNLINKING_POS = function UNLINKING_POS(strictLocalize) {
  return strictLocalize({
    id: "asarqc",
    defaultMessage: "Unlinking POS"
  });
};
var TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION = function TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION(strictLocalize) {
  return strictLocalize({
    id: "DsdM7O",
    defaultMessage: "You can disconnect your current POS integration by clicking the user-icon button in the upper-right corner of the retailer portal and selecting the “My [INTEGRATION NAME] POS” option. On this page, in the top right hand corner click on “Settings”. Once you are in your Settings, you can scroll down to “Disconnect [INTEGRATION NAME] POS”."
  });
};
var TO_RECONNECT_A_DIFFERENT_ACCOUNT = function TO_RECONNECT_A_DIFFERENT_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "4fMVwv",
    defaultMessage: "To reconnect a different account, you can refresh the page and simply click on “Connect to Square”, “Connect to Shopify” or “Connect to Clover”."
  });
};